import { BreakoutIcon } from '@daily/shared/components/Icons/BreakoutIcon';
import { Text } from '@daily/shared/components/Text';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSidebarView } from '../../lib/state/core';
import { TrayButton } from './TrayButton';

interface Props extends React.ComponentProps<typeof TrayButton> {}

export const BreakoutControls: React.FC<Props> = ({ onClick, ...props }) => {
  const { t } = useTranslation();
  const [sidebarView, setSidebarView] = useSidebarView();

  const handleBreakoutClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    setSidebarView(sidebarView === 'breakout' ? null : 'breakout');
    onClick?.(ev);
  };

  return (
    <div className="breakout-controls">
      <TrayButton
        id="breakout-controls"
        onClick={handleBreakoutClick}
        {...props}
      >
        <BreakoutIcon />
        <Text>{t('general.breakoutRooms')}</Text>
      </TrayButton>
    </div>
  );
};
